import * as THREE from 'three';
/**
 * Transforms measured off the loaded computers model at runtime.
 *
 * The camera keyframes are constructed before the model finishes loading, so
 * they read from this shared record every frame instead of hardcoding a
 * position. `ready` stays false until Computers has measured the hero screen.
 */
export const heroScreen = {
    ready: false,
    /** World-space center of the screen glass */
    position: new THREE.Vector3(0, 2145, -2430),
    /** World-space orientation of the screen, local +Z is the outward normal */
    quaternion: new THREE.Quaternion(),
    /** World-space outward normal of the screen */
    normal: new THREE.Vector3(0, 0, 1),
    /** World-space width of the screen glass */
    width: 1203,
    /** World-space height of the screen glass */
    height: 881,
};
